export default (config = {}) => ({
   siteUrl: config.siteUrl || '',
   dynamicForm(handle, id) {

      const form = document.getElementById(id);

      fetch(
         this.siteUrl + 'dynamic/form?form=' + handle
      )
      .then(
         response => {
               if (!response.ok) { throw response }
               return response.json()
         }
      )
      .then(
         data => {

               form.querySelector('input[name=' + data.csrf.name + ']').value = data.csrf.value;

               form.querySelector('input[name=formHash]').value = data.hash;

               form.querySelector('input[name=freeform_payload]').value = data.payload;

               let honeypot = data.honeypot;
               let honeypotInput = form.querySelector('input[name^="freeform_form_handle"]');
               honeypotInput.setAttribute('id', honeypot.name);
               honeypotInput.setAttribute('name', honeypot.name);
               honeypotInput.value = honeypot.hash;

         }
      );

   }
})
